import React, { Component } from 'react';

import {
  Page,
  Card,
  Layout,
  SkeletonBodyText,
  Button,
  Pagination,
  Toast,
  SkeletonPage,
  BlockStack,
  Link,
  Icon,
  // Select,
  Modal,
  // InlineStack,
  Box,
  Checkbox,
  Popover,
  InlineStack,
  // OptionList,
  SkeletonDisplayText,
  
} from "@shopify/polaris";

import {
  // ChevronLeftMinor,
  // SortMinor,
  UploadMajor,
  MinusMinor,
  SearchMajor
} from '@shopify/polaris-icons';
import utils from '../../../../utils/utils'
import { withRouter } from 'react-router-dom';
// import LazyLoad from 'react-lazyload';
import AppBridge from '../../../../utils/appBridge';

import { 
  getGetProductAddSuccess,
  reqGetFindProductListCateData,reqGetUserPoints,reqGetUserSubcribe,reqGoogleAnalytics,reqPostFindProductAdd
} from '../../../../api';

import '../index.css';
import intl from "../../../../i18n/intl";
import { store } from '../../../../store';
// import { connect} from "react-redux";
import ImportDsmModal from '../../SubscriptionPaid/components/ImportDsmModal';
import UpgradePlanProductRedeemModal from '../../SubscriptionPaid/components/UpgradePlanProductRedeemModal';
import { changeBannerData, changePersonLevel } from '../../../../slice';
import ListItem from '../components/ListItem';
import { connect } from 'react-redux';
class RecommendedCategory extends Component {
  state = {
    pageTitle: 'Products',
    // 产品导入成功弹窗
    chargeError:false,
    
    sortBy: '',

    // 列表原始数据
    pageData: [],
    // DIV列表数据
    ListDivHtml: <div></div>,

    loadingPage: false,
    isSearching: '0',
    page: 1,
    size: 80,
    pageValue: "",
    hasPrevious: false,
    hasNext: true,
    ShowCountNumber: 0,
    importantLimit:0,//商品导入限制
    importantDsmModal:false,//dsm产品导入限制
    importantDay:3,//每天限定导入
    productAddSuccess:false, // 是否不再显示导入成功弹窗
    selectAgain:false, // 选择不再弹窗
    popoverSort:false,
    priceRangeActive: false, //是否展示价格范围
    minPrice: "",
    maxPrice: "",
    currentMinPrice:'',
    currentMaxPrice:'',
    queryValue:'',
    ProductsTitle:'',
    ProductsTitleInfo:'',
    userPointsData:{
      available_points:0,
      total_points:0
    },
    userPointsRedeem:{
      open:false,
      isPoints:false,
      recordKey:'',
      cj_pid:'',
      productId:''
    }
  };

  //进入页面调用接口
  componentDidMount() {
    let allow = false;
    let title = '';
    let person = store.getState().languageReducer.subScriptData;
    this.getUserPoints()
    switch (this.props.type) {
      case 'new':
        if (person?.level === 0) {
          allow = false;
        }else{
          title = intl.get("New Products");
          allow = true;
        }
        break;
      case 'winning':
        if (person?.level === 0) {
          allow = false;
        }else{
          title = intl.get("Winning Products");
          allow = true;
        }
        break;
      case 'discount':
        title = intl.get("Discount Products");
        allow = true;
        break;

      default:
    }
    if(AppBridge && AppBridge.exist()) {
      AppBridge.setTitleBar('Winning Products','/admin/find_products')
    }
    if (!allow) {
      // 标识错误，直接返回
      utils.routeListen('/admin/find_products')
      utils.routeJump(this,'/admin/find_products')
      // this.props.history.push('/admin/find_products');
      return false;
    }
    let params = new URLSearchParams(window.location.search);
    let linkPage = params.get("linkPage");
    let minPrice = params.get('minPrice');
    let maxPrice = params.get('maxPrice');
    window.onscroll = this.onScroll;
    document.documentElement.style.scrollBehavior="smooth";

    this.setState({
      pageTitle: title,
      page: linkPage ? linkPage : 1,
      minPrice:minPrice ? minPrice : '',
      maxPrice:maxPrice ? maxPrice : '',
      currentMinPrice:minPrice ? minPrice : '',
      currentMaxPrice:maxPrice ? maxPrice : '',
    }, () => {
      this.getPageData();
    })
  }

  onScroll = () => {
    let obj = document.getElementById('showTopButton');
    if (obj) {
      if (document.documentElement.scrollTop > 2250 ) {
        obj.style.display = 'block';
      }
      if (document.documentElement.scrollTop < 2250) {
        obj.style.display = 'none';
      }
    }
  }

  scrollToTop = () => {
    document.documentElement.scrollTop = 0
  }

  toggleToast = (showToastText, showToastIserror=false) => {
    this.setState(({ showToast }) => ({
      showToast: !showToast,
      showToastText: showToastText,
      showToastIserror: showToastIserror
    }));
  };
// 获取积分
getUserPoints = async ()=>{
  let res = await reqGetUserPoints()
  if (res.code === '200') {
    this.setState({
      userPointsData:res.data
    })
  }
}
handlePointsRedeem = async()=>{
   // 产品导入到 sourcing - product列表
   let recordKey = this.state.userPointsRedeem.recordKey;
   let cj_pid = this.state.userPointsRedeem.cj_pid;
   let productId = this.state.userPointsRedeem.productId;
   if (productId !== '') {
    let data = this.state.pageData;
   data[recordKey].loading = 1;
   this.setState(
     {
       pageData: data,
     }
   );
   this.updatePageDetail(data);
   const params = {
     record_id: productId,
     pid: cj_pid,
     tag: this.props.type,
     is_point: 1
   };
   const response = await reqPostFindProductAdd(params);
   if (response.code === "200") {
     this.setState({ importantLimit: this.state.importantLimit + 1 });
     data[recordKey].dsm_pid = response.data.id;
     data[recordKey].loading = 0;

     this.setState(
       {
         pageData: data,
         chargeError: this.state.productAddSuccess ? false : true,
       }
       );
       this.updatePageDetail(data)
       setTimeout(() => {
         if (this.state.productAddSuccess) {
           this.toggleToast("Added successfully");
         }
       }, 10);
       this.setState({
        userPointsRedeem:{
          open:false,
          isPoints:false,
          recordKey:'',
          cj_pid:'',
          productId:''
        },
        userPointsData:{
          ...this.state.userPointsData,
          available_points:Number(this.state.userPointsData.available_points) - 150
        }
      })
   } else {
     data[recordKey].loading = 0;
     this.setState({
       pageData: data,
     });
     store.dispatch(
       changeBannerData({
         bannerData: {
           show: true,
           desc: response.msg,
         },
       })
     );
   }
   }
   
}
  // 获取列表数据
  getPageData = async(isSearch=false) =>{
    if(isSearch){
      this.setState({
        isSearching:'1',
        hasPrevious : false,
        hasNext : false,
      });
    }else{
      this.setState({
        loadingPage: true,
        hasPrevious : false,
        hasNext : false,
      });
    }
    store.subscribe(()=>{
      let person = store.getState().languageReducer.subScriptData;
      if (person?.level < 2) {
        // 标识错误，直接返回
        utils.routeListen('/admin/find_products')
        utils.routeJump(this,'/admin/find_products')
        
        return false;
      }
    })
    const params = {
      page: this.state.page,
      size: this.state.size,
      product_name: this.state.queryValue,
      min_price: this.state.minPrice,
      max_price: this.state.maxPrice,
      // sort: this.state.sortBy,
      type: this.props.type
    };
    const response = await reqGetFindProductListCateData(params);
    if(response.code==='200'){
      let person = store.getState().languageReducer.subScriptData;
      if (Object.values(person).length > 0) {
        this.setState({
          productAddSuccess:person?.bfs_pop?.is_bfs_import_product ? person?.bfs_pop?.is_bfs_import_product : false
        })
      }
      let res = await reqGetUserSubcribe();
      if (res.code === '200') {
        this.setState({
          importantLimit:Number(res?.data?.limit?.dsm),
          importantDay:Number(res?.data?.day?.dsm)
        })
      }

      let getData = response.data;

      this.setState({
        loadingPage: false,
        pageData: getData.list,
        total: getData.count,
        ShowCountNumber: getData.count,
        isSearching: '0',
        pageValue:"",
      });
      this.updatePageDetail(getData.list);

      // 更新分页数据
      if(this.state.page > 1){
        this.setState({
          hasPrevious:true
        });
      }else{
        this.setState({
          hasPrevious:false
        });
      }

      const maxPage =  Math.ceil(response.data.count / this.state.size);
      if(this.state.page < maxPage){
        this.setState({
          hasNext:true,
          PageCount:maxPage
        });
      }else{
        this.setState({
          hasNext:false,
          PageCount:maxPage
        });
      }

    }else{
      // this.toggleToast(response.msg,true);
      store.dispatch(changeBannerData({bannerData:{
        show:true,
        desc:response.msg
      }}));
      this.setState({
        loadingPage: false,
        pageData: [],
        isSearching: '0',
      });
    }
    // 清除浏览器链接上的参数
    try {
      let currentUrl = window.location.href;
      if (currentUrl.indexOf("?") !== -1) {
        currentUrl = currentUrl.replace(/(\?|#)[^'"]*/, "");
        if (!!(window.history && window.history.pushState)) {
          window.history.pushState({}, 0, currentUrl);
        }
      }
    } catch (error) {
      console.warn(error);
    }
  }

  // 更新列表信息
  updatePageDetail(pageData){
    let data = pageData;
    let listHtmlContent = <div></div>;

    if(data.length > 0){
      listHtmlContent = (
        <ListItem
        data={data}
        linkPage={this.state.page}
        handleToSourcingList={this.handleToSourcingList}
        handleJumpToDetail={this.handleJumpToDetail}
      />
      );
    }

    this.setState({
      ListDivHtml: listHtmlContent,
      ShowCountNumber: data.length,
    });
  }

  // 页面操作
  handleToSourcingList = async (recordKey, productId, cj_pid, dsm_pid) => {
    if(dsm_pid !== 0){  // 跳转到sourcing - product 页面
      utils.routeListen('/admin/import-list')
      utils.routeJump(this,'/admin/import-list?ids='+dsm_pid)
      return;

    } else {
      let person = store.getState().languageReducer.subScriptData;
      // 导入限制
      if (
        (person?.level === 0 && this.state.importantLimit >= 3) ||
        (person?.level === 4 && this.state.importantLimit >= 100)
      ) {
        if (this.state.userPointsData.available_points >= 150) {
          this.setState({
            userPointsRedeem:{
              open:true,
              isPoints:true,
              recordKey:recordKey,
              cj_pid:cj_pid,
              productId:productId
            }
          })
        }else {
          this.setState({ importantDsmModal: true });
        }
        return;
      }

      //Search Product页面Add to products list按钮点击gtag
      reqGoogleAnalytics('click', 'searchproduct_importproduct_click');
      
      // 产品导入到 sourcing - product列表
      let data = this.state.pageData;
      data[recordKey].loading = 1;
      this.setState({
        pageData: data,
      })
      this.updatePageDetail(data);

      const params = {
        record_id: productId,
        pid: cj_pid,
        tag: this.props.type,
        is_point:0
      };
      const response = await reqPostFindProductAdd(params);
      if (response.code === '200') {
        // this.toggleToast(response.msg,false);
        this.setState({importantLimit:this.state.importantLimit+1})
        data[recordKey].dsm_pid = response.data.id;
        data[recordKey].is_green = 1;
        data[recordKey].loading = 0;

        this.setState(
          {
            pageData: data,
            chargeError:this.state.productAddSuccess ? false : true,
          },
          () => {
            if (this.state.productAddSuccess) {
              this.toggleToast("Added successfully")
            } 
          }
          );
          this.updatePageDetail(data);

      } else {
        // this.toggleToast(response.msg,true);
        store.dispatch(changeBannerData({bannerData:{
          show:true,
          desc:response.msg
        }}));
      }
    }
  }

  /**
   * 判断链接跳转
   * 
   * 说明：如果 AppBridge实例存在代表Shopify内嵌模式，否在代表Shopify站外访问
   * 
   * @param {string} uri 路由，没有携带域名
   */
   handleJumpLink = (uri) => {
    if (AppBridge.exist()) {
      utils.routeListen(uri)
      utils.routeJump(this,uri)

    } else {
      try {
        // 获取当前域名
        // let localHost = window.location.protocol + "//" + window.location.hostname + (window.location.port ? ':' + window.location.port : '');

        // const w = window.open('about:blank');
        // w.location.href = localHost + uri;
        utils.routeListen(uri)
        utils.routeJump(this,uri)
      } catch (error) {
        utils.routeListen(uri)
        utils.routeJump(this,uri)
      }
    }
  }

  // 跳转到产品详情页面
  handleJumpToDetail = (id) => {
    
    if (AppBridge && AppBridge.exist()) {
      this.handleJumpLink('/admin/find_products/product-info?filter='+id+'&type='+this.props.type+'&linkPage='+this.state.page+"&minPrice="+this.state.minPrice+'&maxPrice='+this.state.maxPrice);
      return false;
    }else {
      window.open('/admin/find_products/product-info?filter='+id+'&type='+this.props.type+'&linkPage='+this.state.page+"&minPrice="+this.state.minPrice+'&maxPrice='+this.state.maxPrice,'_blank')
    }
    return false;
  }

  // select change
  handleSelectChange = (value) =>{
    this.setState({
      sortBy: value[0],
      page: 1,
    },()=>{
      setTimeout(() => {
        this.getPageData(true);
      }, 600);
    })
  }

  callChargeErrorClosed = () => {
    this.setState({
      chargeError: false,
    });
    if (!this.state.productAddSuccess && this.state.selectAgain) {
      this.selectAgainClose()
    }
  };
   // 不再弹出导入成功弹窗
   selectAgainClose = async () => {
    try {
      let res = await getGetProductAddSuccess()
      if (res.code === '200') {
        this.setState({
          productAddSuccess:true
        })
        let getData = store.getState().languageReducer.subScriptData;
        this.props.dispatch(changePersonLevel({infoData:{...getData,bfs_pop:{...getData.bfs_pop,is_bfs_import_product:true}}},true))
      }
    } catch (error) {
      
    }
  };
   // 搜索输入
   handleFiltersQueryChange = (value) => {
    this.setState({
      queryValue: this.filterEmoji(value),
      page: 1,
    });
  };
   // 过滤表情
   filterEmoji = (str) => {
    const regex = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
    return str.replace(regex, "");
  };
  getSeachTitle = () => {
    let title = "";
    let title_info = "";
    if (this.state.queryValue !== "") {
      title = "";
      title_info = '>"' + this.state.queryValue + '"';
    }

    this.setState(
      {
        ProductsTitle: title,
        ProductsTitleInfo: title_info,
        page: 1,
      },
      () => {
        this.getPageData(true);
      }
    );
  };
  togglePriceRangeActive = () => {
    this.setState({
      priceRangeActive: !this.state.priceRangeActive,
    });
  };
  toggleClearPriceRangeActive = () => {
    this.setState({
      priceRangeActive: !this.state.priceRangeActive,
      minPrice:'',
      maxPrice:''
    });
    if (this.state.currentMinPrice !== '' && this.state.currentMaxPrice !=='') {
      this.setState({
        currentMinPrice:'',
        currentMaxPrice:''
      },()=>{
        this.getPageData(true)
      });
    }
  };
  handlePriceRange = (val, type) => {
    this.setState({
      [type]: val,
      priceError:false
    });
  };
  handlePriceRangeBlur = (val, type) => {
    this.setState({
      priceError:false
    })
    if (type === "maxPrice") {
      if (this.state.minPrice >= val && val !== 0) {
        this.setState({
          [type]: Math.round((Number(this.state.minPrice) + 1) * 100) / 100,
        });
        return;
      }
      this.setState({
        [type]: val <= 0 ? 0.1 :  Math.round(Number(val) * 100) / 100,
      });
    } else {
      if (Number(val) >= Number(this.state.maxPrice) && this.state.maxPrice !=='') {
        this.setState({
          [type]: Number(this.state.maxPrice) - 0.1,
        });
      }else {
      this.setState({
        [type]: val < 0 ? 0.1 : Math.round((Number(val)* 100)) / 100,
      });
    }
    }
  };
  handlePriceRangeApply = () => {
    if (this.state.minPrice !== "" && this.state.maxPrice !== "") {
      this.setState({
        currentMinPrice: this.state.minPrice,
        currentMaxPrice: this.state.maxPrice,
      })
      this.getPageData(true);
      this.togglePriceRangeActive()
    }else {
      this.setState({
        priceError:true
      })
    }
  };

  render() {
    const toastMarkup = this.state.showToast ? <Toast content={this.state.showToastText} duration={2000} onDismiss={()=>this.toggleToast('')} error={this.state.showToastIserror} /> : null;

    const {
      isSearching, pageTitle, ShowCountNumber, ListDivHtml
    } = this.state;

    const initSkeletonPage = (
      <div>
         <SkeletonPage fullWidth={true}>
          <Layout>
          <Layout.Section>
          <BlockStack gap={400}>
          <Card>
          <BlockStack gap={400}>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          <SkeletonBodyText lines={3}/>
          </BlockStack>
          </Card>
          <div className="product-list">
                {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13, 14, 15].map(
                  (item, key) => (
                    <div key={key} className="find-product-item">
                      <Card>
                        <BlockStack gap={400}>
                          <SkeletonDisplayText size="large" />
                          <SkeletonBodyText lines={3} />
                        </BlockStack>
                      </Card>
                    </div>
                  )
                )}
          </div>
          </BlockStack>
        </Layout.Section>
          </Layout>
        </SkeletonPage>
      </div>
    )

    // const sortOptions = [
    //   {label: intl.get("Newest to oldest"), value: ''},
    //   {label: intl.get("Price:low to high"), value: 'price_asc'},
    //   {label: intl.get("Price:high to low"), value: 'price_desc'},
    //   {label: intl.get("Rating:high to low"), value: 'rating_desc'}
    // ];

    // 产品导入成功提示
    const SingleOperationTipsModal =
    (
      <Modal
      open={this.state.chargeError}
      onClose={this.callChargeErrorClosed}
      title={intl.get("Product imported successfully")}
    >
      <Box className='product_success_content'>
        <div style={{ fontSize: "16px", color: "#202223",padding:"16px" }}>
        {intl.get("You can go to the")}{" "}
          <span style={{ fontSize: "16px",fontWeight:700, color: "#303030" }}>
            {intl.get("List Products > Not Listed")}
          </span>{" "}
          {intl.get("to view and edit the product.")}
        </div>
        
        <Box className='product_success_button'>
        <Checkbox
              checked={this.state.selectAgain}
              label={intl.get("Don't remind me again")}
              onChange={()=>this.setState(({
                selectAgain:!this.state.selectAgain
              }))}
            />
          <Button variant="primary" onClick={this.callChargeErrorClosed}>
          {intl.get("OK")}
          </Button>
        </Box>
      </Box>
    </Modal>
    )

    // 空数据显示
    const EmptyProductList = (ShowCountNumber === 0) ? (
      <div style={{textAlign:"center",marginTop:'60px',minHeight:'650px'}}>
          <p style={{fontSize:'20px',opacity:'1',marginBottom:'35px'}}>{intl.get("Sorry! Not yet on the shelves.")}</p>
          <p style={{fontSize:'20px',opacity:'1',marginBottom:'0'}}>{intl.get("We will put better products on the shelves as soon as possible.")}</p>
      </div>
    ) : '';

    var footerContentMsg ='';
    if(this.state.total > 0){
      const startNum = (((this.state.page - 1) * this.state.size) + 1);
      const endNum   = (this.state.page * this.state.size>this.state.total)?this.state.total:this.state.page * this.state.size;
      // footerContentMsg = <div className="Pagination_Result__Footer">{"Showing " + startNum + " - "+ endNum + " of " + this.state.total + " results"}</div>;
      footerContentMsg = <div>{intl.get("Showing {{startNum}} - {{endNum}} of {{total}} results (Total {{PageCount}} pages)", startNum, endNum, this.state.total,this.state.PageCount)}</div>;
    }

    // 控制列表两个产品之间间距显示
    // let smallSpacingClass = (ShowCountNumber <= 4) ? 'small_spacing' : '';

    const PaginationSettings = this.state.loadingPage ? '' :
        (ShowCountNumber !== 0) ?
            <div className="Polaris-New-Pagination">
                <Pagination
                  label={footerContentMsg}
                  hasPrevious = {this.state.hasPrevious}
                  onPrevious={() => {
                    this.setState(({page:Number(this.state.page) - 1}),()=>{
                      this.getPageData(true);
                    });
                  }}
                  hasNext = {this.state.hasNext}
                  onNext={() => {
                    this.setState(({page:Number(this.state.page) + 1}),()=>{
                      this.getPageData(true);
                    });
                  }}
              />
              <div>
              <input 
                className="Page_input" 
                type="text" 
                value={this.state.pageValue}  
                maxLength={"8"}
                onChange={(e)=>{
                  if(Number.isInteger(Number(e.target.value)) ){
                        this.setState({
                          pageValue:e.target.value
                        })
                  }
                }
                } />
                <span 
                  className="Page_Jump"
                  onClick={()=>{
                    if (this.state.PageCount === 1) return false;
                    let page = 1;
                    if(this.state.pageValue > this.state.PageCount){
                        page = this.state.PageCount
                    }
                    if(this.state.pageValue > 1 && this.state.pageValue <= this.state.PageCount){
                        page = this.state.pageValue
                    }
                    
                    this.setState({
                      page:page
                    },()=>{
                      this.getPageData(true)
                    })
                  }
                }>{intl.get("Go to")}</span>
              </div>
            </div> : '';

    const pageContent = this.state.loadingPage ? initSkeletonPage : (
      <Page fullWidth backAction={
        AppBridge.exist() ? undefined : {
             content: pageTitle,
             onAction: ()=>{utils.routeListen('/admin/find_products')
             utils.routeJump(this,'/admin/find_products')}
           }
       }
       title={AppBridge.exist() ? '' : pageTitle}>
        <Layout>
          <Layout.Section>
          <Box className='recommended_category_img recommended_category_img_pc '>
              <img src='/new-product/winning_product_big.png' alt='Dropshipman' />
            </Box>
            <Box className='recommended_category_img recommended_category_img_mob'>
              <img src='/new-product/winning_product_m.png' alt='Dropshipman' />
            </Box>
            <Box className="cate_box_list">
                <div className="cate_list" style={{ position: "relative" }}>
                  <div
                    className="input_search_div"
                    style={{
                      flex: 1,
                      margin: "0 20px 0 0",
                      position: "relative",
                    }}
                  >
                    <input
                      type="text"
                      placeholder={intl.get("Search Products")}
                      autoComplete="off"
                      maxLength="100"
                      value={this.state.queryValue}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          this.getSeachTitle();
                        }
                      }}
                      className="search_input"
                      onChange={(e) => {
                        this.handleFiltersQueryChange(e.target.value);
                      }}
                    />
                    <div
                      className="search_input_img"
                      onClick={() => {
                        this.getSeachTitle();
                      }}
                    >
                     <Icon
                      source={SearchMajor}
                      tone="base"
                    />
                    </div>
                  
                  </div>
                  <div className="filter_button">
                    {/* <div className="cate_hover_find">
                      <Button onClick={()=>this.setState({categories:!this.state.categories})}>
                        <InlineStack align="space-between">
                          <Text>All Categories</Text>
                          <Icon source={CaretDownMinor} tone="base" />
                        </InlineStack>
                      </Button>
                    </div> */}
                    <div className="price_range_find">
                      <Popover
                        active={this.state.priceRangeActive}
                        activator={
                           <Button onClick={() => this.togglePriceRangeActive()} disclosure>
                           <InlineStack blockAlign="space-between">
                           <span>{(this.state.currentMinPrice !=='' && this.state.currentMaxPrice !== '') ? `$${this.state.currentMinPrice} - $${this.state.currentMaxPrice}` : intl.get("Price range")}</span>
                       </InlineStack>
                       </Button>
                        }
                        autofocusTarget="container"
                        onClose={()=>this.togglePriceRangeActive()}
                      >
                        <div className="price_range_find_content">
                          <div style={{ fontSize: 16, fontWeight: 600 }}>
                            Price range
                          </div>
                          <div className="price_range_find_input">
                            <div>
                              <input
                                type="text"
                                className={this.state.priceError && this.state.minPrice === '' ? 'border_input_price' : '' }
                                onBlur={(e) => {
                                  if (
                                    !isNaN(parseFloat(e.target.value))
                                  ) {
                                    this.handlePriceRangeBlur(
                                      Number(e.target.value),
                                      "minPrice"
                                    );
                                  }
                                }}
                                onChange={(e) => {
                                  if (
                                    !isNaN(parseFloat(e.target.value)) || e.target.value === ''
                                  ) {
                                    this.handlePriceRange(
                                      e.target.value,
                                      "minPrice"
                                    );
                                  }
                                }}
                                maxLength={6}
                                value={this.state.minPrice}
                                placeholder="$ Min"
                              />
                            </div>
                            <div>
                              <Icon source={MinusMinor} tone="base" />
                            </div>
                            <div>
                              <input
                                type="text"
                                maxLength={6}
                                className={this.state.priceError && this.state.maxPrice === '' ? 'border_input_price' : '' }
                                onBlur={(e) => {
                                  if (
                                    !isNaN(parseFloat(e.target.value))
                                  ) {
                                    this.handlePriceRangeBlur(
                                      Number(e.target.value),
                                      "maxPrice"
                                    );
                                  }
                                }}
                                onChange={(e) => {
                                  if (
                                    !isNaN(parseFloat(e.target.value)) || e.target.value === ''
                                  ) {
                                    this.handlePriceRange(
                                      e.target.value,
                                      "maxPrice"
                                    );
                                  }
                                }}
                                value={this.state.maxPrice}
                                placeholder="$ Max"
                              />
                            </div>
                          </div>
                          <p style={{visibility: this.state.priceError ? 'visible' : 'hidden',margin:'5px 0',color:'red'}}>Price is required.</p>
                          <div className="price_range_find_button">
                            <Button
                              onClick={() => this.toggleClearPriceRangeActive()}
                            >
                              Clear
                            </Button>
                            <Button
                              variant="primary"
                              onClick={() => this.handlePriceRangeApply()}
                            >
                              Apply
                            </Button>
                          </div>
                        </div>
                      </Popover>
                    </div>
                  </div>
                </div>
              </Box>

            {/* 空数据显示 */}
            <div style={{position:'relative'}}>

              {EmptyProductList}
              
              <div className="Product__Loading" style={{display: (isSearching === '1' && ShowCountNumber === 0)?'block':'none',backgroundColor:'unset'}}>
                <div className="Product__Loading_Image">
                  <img style={{width:'32px',height:'32px',verticalAlign:'middle'}} src='/loading.gif' alt="loading" />
                </div>
              </div>
            </div>

            {/* Start: 列表 */}
            <div style={{position:'relative'}}>
              <section className="Product_Resource_Wrapper">
                {/* <div className="Border_Mask Left"></div>
                <div className="Border_Mask Right"></div>
                <div className="Border_Mask Bottom"></div>

                <div className={"Product_Resource_Container " + smallSpacingClass}> */}
                  {/* 列表 div 对象 */}
                  {ListDivHtml}
                {/* </div> */}
              </section>

              <div className="Product__Loading" style={{display: (isSearching === '1' && ShowCountNumber > 0)? 'block' : 'none'}}>
                <div className="Product__Loading_Image">
                  <img style={{width:'32px',height:'32px',verticalAlign:'middle'}} src='/loading.gif' alt="loading" />
                </div>
              </div>
            </div>
            {/* End: 列表 */}

            {/* 分页数据 */}
            {PaginationSettings}

          </Layout.Section>
        </Layout>
      </Page>
    )

    // 返回顶部按钮
    const RoundButton = (
      <Link onClick={this.scrollToTop}>
        <div className='top_position'>
        <div className="up_major">
            {/* <img
              src={"/xiangshang.png"}
              style={{ width: "35px", height: "35px" }}
              alt=""
            /> */}
            <Icon source={UploadMajor} />
          </div>
        </div>
      </Link>
    )

    return (
      <div className='_my_product'>
        {pageContent}
        {toastMarkup}

        {!this.state.productAddSuccess && SingleOperationTipsModal}
         {/* dsm产品导入限制 */}
         <ImportDsmModal importOpen={this.state.importantDsmModal} num={this.state.importantDay} setImportOpen={()=>this.setState({importantDsmModal:false})}/>
         <UpgradePlanProductRedeemModal 
        num={this.state.importantDay}
        upgradeOpen={this.state.userPointsRedeem.open}
        pointsData={this.state.userPointsData}
        handlePointsRedeem={()=>this.handlePointsRedeem()}
        setUpgradeOpen={()=>this.setState({
          userPointsRedeem:{
            open:false,
            isPoints:false,
            recordKey:'',
            cj_pid:'',
            productId:''
            }})}/>
        <div id='showTopButton'>
          {RoundButton}
        </div>
      </div>
    );
  }
}
// const mapStateToProps = state => {
//   return {
//     subScriptData: state.languageReducer.subScriptData
//   }
// }
export default connect()(withRouter(RecommendedCategory));